import React, { useContext } from 'react';
import { getAppEnv } from '../../../../../config/env';
import './cabTripType.css';
import {
  AIRPORT,
  CAB_TO_AIRPORT,
  OUTSTATION,
  OUTSTATION_ONE_WAY,
  RENTALS
} from '../../../../constants/tripTypes';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../../CabsLandingContext';
import { SET_TRAVELFOR } from '../../cabsLandingPageState';
import {
  MOB_CABS_LANDING_AIRPORTCABS_CLICK,
  MOB_CABS_LANDING_HOURLYRENTALS_CLICK,
  MOB_CABS_LANDING_OUTSTATIONCABS_CLICK
} from '../../../../constants/omnitureConstants';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const CabsTripTypes = () => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);

  const { travelFor, trackTemplateEvent } = cabsLandingContext;
  const setTravelFor = triptype => {
    dispatch && dispatch({ type: SET_TRAVELFOR, newStateValue: triptype });
  };

  const tripTypes = [
    {
      type: OUTSTATION,
      diplayText: 'Outstation',
      img: 'car_img.webp',
      secText: 'Cabs',
      defaultTripType: OUTSTATION_ONE_WAY
    },
    {
      type: AIRPORT,
      diplayText: 'Airport',
      img: 'at_img.webp',
      secText: 'Cabs',
      defaultTripType: CAB_TO_AIRPORT
    },
    {
      type: RENTALS,
      diplayText: 'Hourly',
      img: 'hr_img.webp',
      secText: 'Rentals',
      defaultTripType: RENTALS
    }
  ];

  const setTripType = tripType => {
    setTravelFor(tripType.defaultTripType);
    let eventName = MOB_CABS_LANDING_OUTSTATIONCABS_CLICK;
    if (tripType.defaultTripType === CAB_TO_AIRPORT)
      eventName = MOB_CABS_LANDING_AIRPORTCABS_CLICK;
    if (tripType.defaultTripType === RENTALS)
      eventName = MOB_CABS_LANDING_HOURLYRENTALS_CLICK;
    trackTemplateEvent(eventName);
  };

  return (
    <React.Fragment>
      <div className="container">
        <div className="container-box">
          {tripTypes.map((tripType, index) => {
            const notLast = !(index === tripTypes.length - 1);
            const isActive = travelFor.includes(tripType.type);
            return (
              <>
                <div
                  key={index + '_cab_trip'}
                  id={index + '_cab_trip_types'}
                  className={`tripOptionCard ${isActive ? 'active' : ''}`}
                  onClick={() => {
                    setTripType(tripType);
                  }}
                >
                  <div className="horizontalCenter2">
                    <img
                      className="imgStyle"
                      src={`${PUBLIC_URL}/static/public/${tripType.img}`}
                      style={{
                        filter: isActive ? 'brightness(0) invert(1)' : ''
                      }}
                    />
                  </div>
                  <div
                    className="textStyle latoBlack font10 lineHeight12 horizontalCenter2"
                    style={{ color: isActive ? 'white' : '' }}
                  >
                    {tripType.diplayText}
                  </div>
                  <div
                    className="textStyle latoBlack font10 lineHeight12 horizontalCenter2"
                    style={{ color: isActive ? 'white' : '' }}
                  >
                    {tripType.secText}
                  </div>
                </div>
                {notLast ? (
                  <div
                    className="vertlCenter"
                    style={{
                      width: 6,
                      height: 28,
                      backgroundColor: 'rgb(239, 243, 248)'
                    }}
                  ></div>
                ) : null}
              </>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CabsTripTypes;
